module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isRouterAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-box"
  }, [_c('nt-pulse-loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.previewImgUrl) ? _c('nt-preview-image') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10ae1d74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = gKeL
// module chunks = 6